import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { JpClassAttendanceDTOBase } from "./JpClassAttendanceDTOBase";
import type { JpClassSessionStaff } from "./JpClassSessionStaff";
import type { JpClassSignupStaff } from "./JpClassSignupStaff";
import type { TrackedBase } from "./TrackedBase";

export class JpClassAttendanceStaff implements JpClassAttendanceDTOBase, TrackedBase {
  constructor(public readonly attendId: number, public readonly attend: string, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly sessionId: JpClassSessionStaff | null, public readonly signupId: JpClassSignupStaff | null) {
    this.cbiServiceContext = null;
    this.sessionIdLoaded = this.sessionId != null;
    this.sessionIdCached = this.sessionId;
    this.signupIdLoaded = this.signupId != null;
    this.signupIdCached = this.signupId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private sessionIdLoaded: boolean;
  private sessionIdCached: JpClassSessionStaff | null;
  private signupIdLoaded: boolean;
  private signupIdCached: JpClassSignupStaff | null;
  async sessionIdLazy(): Promise<JpClassSessionStaff> {
    if (!this.sessionIdLoaded) {
      this.sessionIdCached = await this.cbiServiceContext!.jpClassService().getJpClassAttendanceStaffSessionId(this.attendId);
      this.sessionIdLoaded = true;
    }
    return this.sessionIdCached!;
  }
  async signupIdLazy(): Promise<JpClassSignupStaff> {
    if (!this.signupIdLoaded) {
      this.signupIdCached = await this.cbiServiceContext!.jpClassService().getJpClassAttendanceStaffSignupId(this.attendId);
      this.signupIdLoaded = true;
    }
    return this.signupIdCached!;
  }
}
